export const SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE';

export const setLanguageCode = code => {
  return { type: SET_LANGUAGE_CODE, payload: code };
};
